import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { AccountRecord } from '../../list/types/accounts.types';

export const accountsEditService = {
  async getAccount(id: string): Promise<AccountRecord> {
    await enforceSettingsPermission('settings.account.view');
    
    const { data, error } = await supabase
      .from('settings_accounts')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    
    return {
      id: data.id,
      companyId: data.company_id,
      accountName: data.account_name,
      accountNumber: data.account_number,
      bankName: data.bank_name,
      bankBranch: data.bank_branch,
      accountHolder: data.account_holder,
      currency: data.currency,
      initialBalance: Number(data.initial_balance),
      currentBalance: Number(data.current_balance),
      status: data.status,
      isDefault: data.is_default,
      description: data.description,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
      createdBy: data.created_by
    };
  },

  async updateAccount(id: string, data: Partial<AccountRecord>) {
    await enforceSettingsPermission('settings.account.update');
    
    const { error } = await supabase
      .from('settings_accounts')
      .update({
        account_name: data.accountName,
        bank_name: data.bankName,
        bank_branch: data.bankBranch,
        account_holder: data.accountHolder,
        status: data.status,
        is_default: data.isDefault,
        description: data.description,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id);

    if (error) throw error;
  }
};
